import { render, staticRenderFns } from "./tx-map.vue?vue&type=template&id=f723373a&scoped=true"
import script from "./tx-map.vue?vue&type=script&lang=js"
export * from "./tx-map.vue?vue&type=script&lang=js"
import style0 from "./tx-map.vue?vue&type=style&index=0&id=f723373a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f723373a",
  null
  
)

export default component.exports